module.exports = __webpack_public_path__ + "static/media/InitialSymbol_ai.bd6161ab.zip";